import React, { useEffect, useState } from "react";
import { Tooltip } from "antd";
import {
  CartesianGrid,
  Cell,
  Line,
  LineChart,
  Pie,
  PieChart,
  ResponsiveContainer,
  XAxis,
  YAxis,
} from "recharts";
import { IoAlarmOutline } from "react-icons/io5";
import { LuBedDouble } from "react-icons/lu";
import { PiTimer } from "react-icons/pi";
import { RiFootprintFill, RiFireFill } from "react-icons/ri";
import Stress from "../../../../../Assets/Images/Svg/Stress.svg";
import Sleep from "../../../../../Assets/Images/Svg/Sleep.svg";
import Body from "../../../../../Assets/Images/Svg/Bodybattery.svg";
import HRV from "../../../../../Assets/Images/Svg/Hrv.svg";
import ActivityBlackIcon from "../../../../../Assets/Images/Svg/activityIconBlack.svg";
import PatientService from "../../../../../Services/PatientService";
import { useSelector } from "react-redux";
import StressData from "../../../GarminCards/StressData";
import SleepData from "../../../GarminCards/SleepData";
import StepData from "../../../GarminCards/StepData";
import HRVData from "../../../GarminCards/HRVData";
import CaloriesData from "../../../GarminCards/CaloriesData";
import BatteryData from "../../../GarminCards/BatteryData";

// // Dummy HRV data
// const hrvData = [
//     { time: "1", value: 28 },
//     { time: "2", value: 34 },
//     { time: "3", value: 42 },
//     { time: "4", value: 38 },
//     { time: "5", value: 50 },
//     { time: "6", value: 54 },
// ];

// // Stress chart data
// const data = [
//     { name: "Segment 1", value: 7, color: "#f97316" }, // Orange
//     { name: "Segment 2", value: 5, color: "#ef4444" }, // Red
//     { name: "Segment 3", value: 8, color: "#3b82f6" }, // Blue
//     { name: "Segment 4", value: 8, color: "#facc15" }, // Yellow
// ];

// // Calories values
// const active = 302;
// const resting = 1061;
// const total = active + resting;
// const activePercent = (active / total) * 100;
// const restingPercent = (resting / total) * 100;

function WatchData({ selectedRpmPatient }) {
  if (selectedRpmPatient?.smartWatchUserId) {
    return (
      <div className="mt-8">
        <div className="flex items-center gap-0.5 my-3">
          <img src={ActivityBlackIcon} alt="activity" className="w-6 h-6" />
          <h3 className="font-bold text-xl">Activities</h3>
        </div>

        <div className="w-full h-48 flex items-center gap-2 overflow-x-auto overflow-y-hidden scroll-smooth">
          <div className="my-1 w-52 shrink-0">
            <StressData smartWatchId={selectedRpmPatient?.smartWatchUserId} />
          </div>
          <div className="my-1 w-52 shrink-0">
            <SleepData smartWatchId={selectedRpmPatient?.smartWatchUserId} />
          </div>
          <div className="my-1 w-52 shrink-0">
            <StepData smartWatchId={selectedRpmPatient?.smartWatchUserId} />
          </div>
          <div className="my-1 w-52 shrink-0">
            <CaloriesData smartWatchId={selectedRpmPatient?.smartWatchUserId} />
          </div>
          <div className="my-1 w-52 shrink-0">
            <BatteryData smartWatchId={selectedRpmPatient?.smartWatchUserId} />
          </div>
          <div className="my-1 w-52 shrink-0">
            <HRVData smartWatchId={selectedRpmPatient?.smartWatchUserId} />
          </div>
        </div>
      </div>
    );
  }
}

export default WatchData;
